<div class="tab-pane engine__tab-pane fade show active" id="flights" role="tabpanel" aria-labelledby="flights-tab">
  <form class="search-form" name="flights" #form="ngForm">
    <div class="search-form__engine search-form__engine--two-rows">
      <div class="search-form__row border-0 m-0">
        <div class="form-check-inline pl-2">
          <label class="form-check-custom">A/R
            <input [(ngModel)]="twoWayFlight" type="radio" name="volo-AR" class="form-check-input" [value]="true">
            <span class="form-check-custom__radio"></span>
          </label>
          <label class="form-check-custom">Solo Andata
            <input [(ngModel)]="twoWayFlight" type="radio" name="volo-A" [value]=" false">
            <span class="form-check-custom__radio"></span>
          </label>
        </div>
      </div>
      <div class="search-form__row">
        <div class="search-form__airport search-form__element">
          <div class="form-group-custom">
            <label for="inputDepartureAirport" class="input-group-zeus__label">Partenza</label>
            <div class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent" id="inputDepartureAirport-select">
              <ng-select [items]="airports$ | async" [typeahead]="airportQuery$"
                         placeholder="Aeroporto di Partenza"
                         name="departureAirport"
                         required
                         [loading]="isLoading" [(ngModel)]="selectedDepartureAirport"
                         [minTermLength]="3" typeToSearchText="Scrivi 3 o piu' caratteri"
                         id = "inputDepartureAirport"
                         class="form-control-custom">
                <ng-template ng-label-tmp let-item="item">
                  <span>{{getAptItemName(item) | stripTags}}</span>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <span [innerHTML]="getAptItemName(item)"></span>
                </ng-template>
              </ng-select>
              <div class="input-group-custom__prepend input-group-custom__prepend--transparent">
                <span class="input-group-custom__icon input-group-custom__icon--transparent" id="basic-addon1"><i class="icon-pin"></i></span>
              </div>
            </div>
          </div>
        </div>
        <div class="search-form__airport search-form__element">
          <div class="form-group-custom">
            <label for="inputArrivalAirport" class="input-group-zeus__label">Destinazione</label>
            <div class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent" id="inputArrivalAirport-select">
              <ng-select [items]="airports$ | async" [typeahead]="airportQuery$"
                         placeholder="Aeroporto di Destinazione"
                         [loading]="isLoading" [(ngModel)]="selectedArrivalAirport"
                         [minTermLength]="3" typeToSearchText="Scrivi 3 o piu' caratteri"
                         name="arrivalAirport"
                         required
                         id = "inputArrivalAirport"
                         class="form-control-custom">
                <ng-template ng-label-tmp let-item="item">
                  <span>{{getAptItemName(item) | stripTags}}</span>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <span [innerHTML]="getAptItemName(item)"></span>
                </ng-template>
              </ng-select>
              <div class="input-group-custom__prepend input-group-custom__prepend--transparent">
                <span class="input-group-custom__icon input-group-custom__icon--transparent" id="basic-addon2"><i class="icon-pin"></i></span>
              </div>
            </div>
          </div>
        </div>
        <div class="search-form__select search-form__element">
          <div class="form-group-custom">
            <label for="farePassenger" class="input-group-zeus__label">Tariffa Passeggero</label>
            <div class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent" id="farePassenger-select">
              <ng-select [items]="passengerTypes" [(ngModel)]="selectedPassengerType" [bindLabel]="'name'"
                         id = "farePassenger"
                         name="farePassenger"
                         required
                         class="form-control-custom"></ng-select>
              <div class="input-group-custom__prepend input-group-custom__prepend--transparent">
                <span class="input-group-custom__icon input-group-custom__icon--transparent" id="basic-addon3"><i class="icon-calendar"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="search-form__row">
        <div class="search-form__select search-form__element">
          <div class="form-group-custom">
            <label for="departureDate-input" class="input-group-zeus__label">Andata</label>
            <div class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent" id="departureDate-input">
              <input readonly [(ngModel)]="selectedDepartureDate"
                     type="text"
                     placeholder="Andata"
                     ngbDatepicker #dpA="ngbDatepicker" (click)="dpA.toggle()"
                     name="departureDate"
                     required
                     class="form-control-custom">
              <div class="input-group-custom__prepend input-group-custom__prepend--transparent">
                <span class="input-group-custom__icon input-group-custom__icon--transparent" id="basic-addon4"><i class="icon-date"></i></span>
              </div>
            </div>
          </div>
        </div>
        <div class="search-form__select search-form__element">
          <div class="form-group-custom">
            <label for="arrivalDate-input" class="input-group-zeus__label">Ritorno</label>
            <div class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent" id="arrivalDate-input">
              <input readonly [(ngModel)]="selectedArrivalDate"
                     type="text"
                     placeholder="Ritorno"
                     ngbDatepicker #dpR="ngbDatepicker" [disabled]="!twoWayFlight" (click)="dpR.toggle()"
                     name="arrivalDate"
                     required
                     class="form-control-custom">
              <div class="input-group-custom__prepend input-group-custom__prepend--transparent">
                <span class="input-group-custom__icon input-group-custom__icon--transparent" id="basic-addon5"><i class="icon-date"></i></span>
              </div>
            </div>
          </div>
        </div>
        <div class="search-form__select search-form__element">
          <div class="form-group-custom">
            <label for="passengers-input" class="input-group-zeus__label">Passeggeri</label>
            <div class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent" id="passengers-input">
              <input readonly (click)="openPassengersModal()" [placeholder]="getPassengerString()"
                     name="passengers"
                     required
                     class="form-control-custom">
              <div class="input-group-custom__prepend input-group-custom__prepend--transparent">
                <span class="input-group-custom__icon input-group-custom__icon--transparent" id="basic-addon6"><i class="icon-user"></i></span>
              </div>
            </div>
          </div>
        </div>
        <button [disabled]="form.invalid" (click)="doSearch()"
                class="search-form__cta search-form__element btn btn--sm btn--brand-color-03 btn__uppercase mt-3">Cerca <i class="icon-search"></i></button>
      </div>
    </div>
  </form>
</div>

<!--
<div>
  <input [(ngModel)]="twoWayFlight" type="radio" name="volo-AR" [value]="true">A/R
  <input [(ngModel)]="twoWayFlight" type="radio" name="volo-A" [value]=" false">Solo andata
</div>

<ng-select [items]="airports$ | async" [typeahead]="airportQuery$"
           placeholder="Aeroporto di Partenza"
           [loading]="isLoading" [(ngModel)]="selectedDepartureAirport"
           [minTermLength]="3" typeToSearchText="Scrivi 3 o piu' caratteri">
  <ng-template ng-label-tmp let-item="item">
    <span>{{getAptItemName(item) | stripTags}}</span>
  </ng-template>
  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
    <span [innerHTML]="getAptItemName(item)"></span>
  </ng-template>
</ng-select>

<ng-select [items]="airports$ | async" [typeahead]="airportQuery$"
           placeholder="Aeroporto di Destinazione"
           [loading]="isLoading" [(ngModel)]="selectedArrivalAirport"
           [minTermLength]="3" typeToSearchText="Scrivi 3 o piu' caratteri">
  <ng-template ng-label-tmp let-item="item">
    <span>{{getAptItemName(item) | stripTags}}</span>
  </ng-template>
  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
    <span [innerHTML]="getAptItemName(item)"></span>
  </ng-template>
</ng-select>

<ng-select [items]="passengerTypes" [(ngModel)]="selectedPassengerType" [bindLabel]="'name'"></ng-select>

<input readonly [(ngModel)]="selectedDepartureDate" type="text" placeholder="Andata" ngbDatepicker #dpA="ngbDatepicker" (click)="dpA.toggle()">

<input readonly [(ngModel)]="selectedArrivalDate" type="text" placeholder="Ritorno" ngbDatepicker #dpR="ngbDatepicker" [disabled]="!twoWayFlight" (click)="dpR.toggle()">

<input readonly (click)="openPassengersModal()" [placeholder]="getPassengerString()">

<button [disabled]="!canSearch()" (click)="doSearch()" class="btn btn-info">Cerca</button>
-->
